/* ============================================================
   CAMILLE.B — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  // ---- Cart Drawer ----
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
    }
  });

  // ---- Intersection Observer — reveal-up ----
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.reveal-up').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  // ---- Equalize prestation item heights across columns ----
  function equalizePrestaItems() {
    var grid = document.querySelector('.prestations__grid');
    if (!grid) return;

    var allCols = Array.prototype.slice.call(grid.children);

    // Reset min-heights
    grid.querySelectorAll('.prestations__item').forEach(function (el) {
      el.style.minHeight = '';
    });

    // Process in groups of 3 (one visual row)
    for (var r = 0; r < allCols.length; r += 3) {
      var rowCols = allCols.slice(r, r + 3);
      var lists = rowCols.map(function (col) {
        return Array.prototype.slice.call(col.querySelectorAll('.prestations__item'));
      });
      var maxItems = Math.max.apply(null, lists.map(function (l) { return l.length; }));

      for (var i = 0; i < maxItems; i++) {
        var items = lists.map(function (l) { return l[i]; }).filter(Boolean);
        if (items.length < 2) continue;
        var maxH = Math.max.apply(null, items.map(function (el) {
          return el.getBoundingClientRect().height;
        }));
        items.forEach(function (el) { el.style.minHeight = maxH + 'px'; });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', equalizePrestaItems);
  window.addEventListener('resize', function () {
    var grid = document.querySelector('.prestations__grid');
    if (grid) grid.querySelectorAll('.prestations__item').forEach(function (el) { el.style.minHeight = ''; });
    equalizePrestaItems();
  });

})();
